import React from 'react';

const ContentTile = ({ title, content, gradient = false, className = "", buttonText, onButtonClick, centerVertically = false }) => {
    const baseClasses = "relative rounded-2xl p-6 sm:p-8 lg:p-12 shadow-xl border border-gray-100 transition-all duration-500 transform hover:scale-[1.02] hover:shadow-2xl group";
    
    const bgClasses = gradient 
        ? "bg-gradient-to-br from-primary to-primary-dark text-white" 
        : "bg-white text-gray-900 hover:bg-gray-50";

    // Determine if we should center vertically (when only title is provided and centerVertically is true)
    const shouldCenter = centerVertically && title && !content && !buttonText;

    return (
        <div className={`${baseClasses} ${bgClasses} ${className} ${shouldCenter ? 'flex flex-col justify-center' : ''}`}>
            {/* Content */}
            <div className={`relative z-10 ${shouldCenter ? 'flex flex-col items-center justify-center flex-grow' : ''}`}>
                {title && (
                    <h3 className={`text-xl sm:text-2xl lg:text-3xl font-bold mb-4 sm:mb-6 break-words ${gradient ? 'text-white' : 'text-gray-900'} ${shouldCenter ? 'text-center' : ''}`}>
                        {title}
                    </h3>
                )}
                <div className={`text-sm sm:text-base lg:text-lg leading-relaxed break-words ${gradient ? 'text-white text-opacity-90' : 'text-gray-700'}`}>
                    {content}
                </div>
                {/* Button */}
                {buttonText && (
                    <div className="text-center mt-6">
                        <span 
                            className="inline-flex items-center text-primary font-semibold text-base hover:text-primary-dark transition-all duration-300 group-hover:translate-x-1"
                        >
                            {buttonText}
                            <i className="ml-2 fas fa-arrow-right text-sm group-hover:translate-x-1 transition-transform duration-300"></i>
                        </span>
                    </div>
                )}
            </div>

            {/* Decorative Elements */}
            <div className="absolute top-4 right-4 w-12 h-12 bg-white bg-opacity-10 rounded-full group-hover:scale-150 transition-transform duration-500"></div>
            <div className="absolute bottom-4 left-4 w-8 h-8 bg-white bg-opacity-5 rounded-full group-hover:scale-125 transition-transform duration-700"></div>
        </div>
    );
};

export default ContentTile;